import { NgClass, NgIf } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, ElementRef, Renderer2, inject } from '@angular/core';
import { RouterLink, RouterModule, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { User } from '../../../core/models/user/user';
import { StorageService } from '../../../core/services/storage/storage.service';
import { UserService } from '../../../core/services/user/user.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [RouterLink, TranslateModule, NgClass, RouterModule, NgIf]
})
export class SidebarComponent implements OnInit {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private storageService = inject(StorageService);
  private userService = inject(UserService);
  private router = inject(Router);

  private openSubMenus: Record<string, boolean> = {};
  protected user : User = new User();
  protected appVersion = environment.version;
  @Output() closeSidebarEvent = new EventEmitter<void>();
  isDarkMode = false;
  ngOnInit() {
    this.user = this.storageService.getUser() || new User();

    // Detect system dark mode preference
    // const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    // this.isDarkMode = prefersDark;

    // // Set localStorage and body class accordingly
    // localStorage.setItem('dark-mode', prefersDark ? 'true' : 'false');
    // if (prefersDark) {
    //   document.body.classList.add('dark');
    // } else {
    //   document.body.classList.remove('dark');
    // }
  }
  isSubMenuOpen(menu: string): boolean {
    return this.openSubMenus[menu] || false;
  }
  toggleSubMenu(menu: string): void {
    this.openSubMenus[menu] = !this.openSubMenus[menu];
  }
  onMainMenuClick(event: Event, menu: string, defaultRoute: string): void {
    event.preventDefault();
    this.openSubMenus[menu] = true; // Ouvre le sous-menu
    this.router.navigate([defaultRoute]);
    this.closeSidebar();
  }
  closeSidebar() {
    this.closeSidebarEvent.emit();
  }
  public isAdmin(): boolean {
    return this.userService.isAdmin(this?.user);
  }
  public isDevUser(): boolean {
    return this.userService.isDevUser(this?.user);
  }
  toggleDarkMode() {
    // Always force light mode
    this.isDarkMode = false;
    localStorage.setItem('dark-mode', 'false');
    document.body.classList.remove('dark');
  }

  // Returns true if any submenu for the given menu is active
  isSubMenuActive(menu: string): boolean {
    if (menu === 'operation') {
      return this.router.isActive('/front/operation', false)
        || this.router.isActive('/front/operation/search', false)
        || this.router.isActive('/front/operation/average-budget', false);
    }
    if (menu === 'previsionnel') {
      return this.router.isActive('/front/previsionnel/budget/details', false)
        || this.router.isActive('/front/previsionnel/difftable', false);
    }
    if (menu === 'patrimony') {
      return this.router.isActive('/front/indicator/pat', false);
    }
    if (menu === 'indicator') {
      return this.router.isActive('/front/indicator/analysis', false)
        || this.router.isActive('/front/previsionnel/statement', false);
    }
    return false;
  }
}
